// extracted by mini-css-extract-plugin
module.exports = {"container":"ArtworkInfo_container__WDG7i","imageContainer":"ArtworkInfo_imageContainer__Ubdh9","titleContainer":"ArtworkInfo_titleContainer__x35PY"};